import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { EGenre } from 'src/app/enumerations/genre.enum';
import { IDemande, IDemandeList } from 'src/app/models/demande.model';
import { IEnumResponse } from 'src/app/models/enumeration.model';
import { IMatiere, IMatiereResponse } from 'src/app/models/matiere.model';
import { INiveauDomaineEtude, INiveauDomaineEtudeResponse } from 'src/app/models/niveau-domaine-etude.model';
import { ClassService } from 'src/app/services/class.service';
import { CommonService } from 'src/app/services/common.service';
import { PersonneService } from 'src/app/services/personne.service';
import { IPersonneTmp } from 'src/app/models/personne-tmp.model';
import { ETypePersonnePhysique } from 'src/app/enumerations/type-personne.enum';
import { Message, MessageService } from 'primeng/api';

@Component({
  selector: 'app-framer-request',
  templateUrl: './framer-request.component.html',
  styleUrls: ['./framer-request.component.scss']
})
export class FramerRequestComponent implements OnInit{
  types: any[];
  selectedType: any;

  demandes: IDemande[] = []
  demandeur: IPersonneTmp = _.stubObject();
  motif: string;
  enumPersonne = ETypePersonnePhysique;

  genres: any[] = [];
  genreSelected: any = _.stubObject();
  enumGenre = EGenre;

  countries: any[] = [];
  countrySelected: any;

  form: UntypedFormGroup;
  formSubmitted = false;

  matieres: IMatiere[] = [];
  matiereSelected: IMatiere;
  
  niveauxDomaines: INiveauDomaineEtude[] = [];
  niveauDomaineMultiSelected: INiveauDomaineEtude;

  addClasse = false;

  messages: Message[] | undefined;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private personneService: PersonneService,
    private classeService: ClassService,
    private readonly enumService: CommonService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.types = [
      { value: this.enumPersonne.INSTITUTION, description: 'Une Ecole / Institution' },
      { value: this.enumPersonne.PARENT, description: 'Un parent' }
    ];

    // this.enumService.getCountry().subscribe(data => {
    //   this.countries = data;
    // })

    this.form = this.formBuilder.group({
      nom: ['', Validators.required],
      prenom: ['', Validators.required],
      telephone: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      dateNaissance: [new Date(), Validators.required],
      genre: ['', Validators.required],
      nationalite: [''],
      adresse: ['']
    });

    this.getGenres();
    this.getsMatieres();
    this.getsNiveauDomaine();
  }

  get demandeCheckForm() {
    return this.form.controls;
  }

  getGenres(): void {
    this.enumService.getGenreEnum().subscribe((response: IEnumResponse) => {
      this.genres = response.objects;
      this.genreSelected = response.objects[0];
    });
  }

  getsMatieres(): void {
    this.classeService.getMatieres().subscribe((response: IMatiereResponse) => {
      this.matieres = response.objects;
    });
  }

  getsNiveauDomaine(): void {
    this.classeService.getClass().subscribe((response: INiveauDomaineEtudeResponse) => {
      this.niveauxDomaines = response.objects;
    });
  }

  showAddBox(): void {
    this.addClasse = true;
  }
  closeAddBox(): void {
    this.addClasse = false;
  }
  
  async saveAddBox(): Promise<void> {
    if(this.matiereSelected === _.stubObject() || this.niveauDomaineMultiSelected === _.stubObject()) {
      this.messages = [{ severity: 'info', summary: 'Important', detail: 'Choisissez la matière et la classe.\n Une description si possible afin de mieux vous satisfaire\nMerci' }];
      return;
    }
    console.log(this.matiereSelected);
    console.log(this.niveauDomaineMultiSelected);
    console.log(this.motif);

    const element: IDemande = _.stubObject();
    element.motif = this.motif;
    element.niveauDomaineEtude = this.niveauDomaineMultiSelected;
    element.matiere = this.matiereSelected;

    this.demandes.push(element);

    this.matiereSelected = _.stubObject();
    this.niveauDomaineMultiSelected = _.stubObject();
    this.motif = null;

    console.log(this.demandes);
  }

  async onSubmit(): Promise<void> {
    // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Message Content' });    
    // return;
    this.formSubmitted = true;
    console.log(this.form.errors);
    console.log(this.form);
    console.log(this.form.invalid);
    
    if(this.form.invalid) {
      this.messages = [{ severity: 'error', summary: 'Incomplet', detail: 'Renseignez les champs obligatoires *' }];
      return;
    }

    this.demandeur.nom = this.form.value.nom;
    this.demandeur.prenom = this.form.value.prenom;
    this.demandeur.dateNaissance = this.form.value.dateNaissance;
    this.demandeur.telephone = this.form.value.telephone;
    this.demandeur.email = this.form.value.email;
    this.demandeur.genre = this.form.value.genre.value;
    this.demandeur.typePersonnePhysique = this.selectedType.value;
    this.demandeur.dateDemande = new Date();
    this.demandeur.valider = false;

    // const tmp = (await this.personneService.getCenter().toPromise()).object;  
    // const tmpe = (await this.personneService.getCenter2().toPromise()).object; 

    // const responseTmp = await this.personneService.create(this.demandeur).toPromise();
    // console.log(responseTmp);
    
    const demandeValide: IDemandeList = _.stubObject();
    demandeValide.demandeList = this.demandes;
    // demandeValide.personneDemandeurTmp = tmp;
    // demandeValide.personneDemandeur = tmpe;
    demandeValide.personnePhysiqueDemandeurTmp = this.demandeur;
    // demandeValide.personnePhysiqueDemandeurTmp = responseTmp.objects[0];
    console.log(demandeValide);
    
    const response = await this.classeService.create(demandeValide).toPromise();
    console.log(response);

    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Demande envoyé' }); 
  }


}
